<style lang="stylus">
    .sc-payway-modal.home-dialog-container-component
        .dialog-slot
            padding 24px 32px
    .sc-payway-container
        z-index 3000

        .scp-type
            overflow auto
            padding-bottom 20px

        .scp-icon
            width 300px
            height 100px
            margin 0 auto
            display flex
            justify-content space-around
            align-items center
            margin-top 20px

            .scp-way
                width 100px
                height 100px
                position relative
                border 1px solid $border-color-base
                border-radius 10px
                cursor pointer
                transition all 0.15s

                &:hover
                    border-color #aaaaaa

                .scpw-check
                    width 25px
                    height 25px
                    position absolute
                    top 0
                    right 0

                .scpw-way
                    width 50px
                    height 50px
                    margin 25px 0 0 25px

            .scp-wxpay
                svg
                    fill #09bb07

            .scp-alipay
                svg
                    fill #00a0e9

        .scp-confirm
            margin 30px auto 0 auto
            color white
            width 100px
            display block

        #wx-qrcode
            display flex
            justify-content space-around
            margin 0 auto
            width 160px
            height 160px
            padding 10px
            border-radius 6px
            background-color #f6f6f6
            >img
                width 140px
                height 140px
        .pay-tips
            display flex
            justify-content center
            margin-top 16px
            .pay-tips-item
                padding 0 8px
                display flex
                align-items center
                color #222
                img
                    padding-right 8px
        .coupon-tip
            text-align center
            transform translateY(-6px)
            color #4091ff
            margin-top 16px
            user-select none
            cursor pointer

        .buy-tips
            font-size 12px
            border-radius 6px
            background-color #f6f6f6
            padding 16px 18px
            margin-top 24px
            color #222
            line-height 20px
            .buy-link
                color #FF7100
                font-weight 600
                cursor pointer
                &:hover
                    text-decoration underline

        .scp-paysucess
            margin 25px 0 20px 0
            overflow auto

            .scpp-icon
                display block
                height 70px
                width 70px
                margin 0 auto

            a
                margin 30px auto 0 auto
                color white
                text-decoration none
                width 100px
                display block

            button
                margin 30px auto 0 auto
                color white
                text-decoration none
                display block
</style>

<template>
    <EDModal v-if="showPay" class="sc-payway-modal" ref="dialog">
        <div class="sc-payway-container" :style="`width:${cloneSucess ? 336 : 417}px`">
            <div v-show="showQrcode" id="wx-qrcode">
                <img ref="wxQrcode" />
            </div>
            <div v-show="showQrcode" class="pay-tips">
                <!-- 支持微信、支付宝扫码 -->
                <span class="pay-tips-item">
                    <img src="@/home/assets/img/wechatpay.svg" />
                    <span>微信</span>
                </span>
                <span class="pay-tips-item">
                    <img src="@/home/assets/img/alipay.svg" />
                    <span>支付宝</span>
                </span>
            </div>
            <div v-show="showQrcode && hasCreditMoney" class="coupon-tip" @click="toCredit">使用社区模板抵用金购买>></div>
            <div v-show="cloneSucess" class="scp-paysucess">
                <iconSymbol class="scpp-icon" name="pay-success" />
                <Button type="primary" @click="close">{{ $t("use") }}</Button>
            </div>
            <div class="buy-tips" v-show="!vip">
                <p>{{ $t("limitTips") }}</p>
                <span class="buy-link" @click="toVip">{{ $t("toVip") }}</span>
                <span v-html="$t('prize')"></span>
            </div>
        </div>
    </EDModal>
</template>

<script>
    import { addJs } from "@/public/utils/tool";
    import appConfig from "@/public/globalConfig";
    import Dialog from "@/home/parts/Dialog.vue";

    export default {
        name: "",
        components: {
            Dialog,
        },
        data() {
            return {
                //支付
                payway: "wxpay",
                showQrcode: false,
                wxPaySuccess: false,
                cloneSucess: false,
                clonedObj: "",
                //保证支付按钮只有第一次按生效
                isSubmitting: false,
                workId: 0,
                timer: null,
            };
        },
        computed: {
            showPay: {
                get() {
                    return this.$store.state.tplCenter.showPay;
                },
                set(val) {
                    this.$store.commit("toTplCenter", {
                        name: "showPay",
                        data: val,
                    });
                    if (!val) {
                        this.showQrcode = false;
                        this.cloneSucess = false;
                        this.$refs.wxQrcode.innerHTML = "";
                        clearTimeout(this.timer);
                        this.wxPaySuccess = false;
                        this.$store.commit("hideDialogMaskState"); // 所有弹窗共用mask，需要主动唤起关闭
                    } else {
                        !this.cloneSucess && this.submitOrder();
                    }
                },
            },
            preItem() {
                return this.$store.state.tplCenter.activeWork;
            },
            mapUrl() {
                if (~location.href.indexOf("/online/")) {
                    return "/online/app.html";
                } else {
                    return "/app.html";
                }
            },
            work() {
                return this.$store.state.tplCenter.activeWork;
            },
            userInfo() {
                return this.$store.state.userInfo;
            },
            hasCreditMoney() {
                return this.$store.state.hasCreditMoney;
            },
        },
        watch: {
            showPay(nv, ov) {
                if (nv) {
                    this.$nextTick(() => {
                        let dom = this.$refs.dialog;
                        dom.show({
                            title: this.cloneSucess ? "克隆成功" : "请扫描下方二维码支付" + this.preItem.price + "元",
                            useDark: this.isPCDarkMode,
                            isPC: this.isPC,
                            closeEvent: () => this.closeModal(),
                        });
                    });
                }
            },
            cloneSucess(nv, ov) {
                if (nv) {
                    this.$nextTick(() => {
                        let dom = this.$refs.dialog;
                        dom.show({
                            title: this.cloneSucess ? "克隆成功" : "请扫描下方二维码支付" + this.preItem.price + "元",
                            useDark: this.isPCDarkMode,
                            isPC: this.isPC,
                            closeEvent: () => this.closeModal(),
                        });
                    });
                }
            },
        },
        mounted() {
            //支付宝付款的回调链接中会有out_trade_no参数，有的话直接克隆
            // let url = new URL(location.href),
            // 	orderId = url.searchParams.get("out_trade_no");
            // if (!orderId) return;
            // let expand = this.isPC ? "?left=false" : "";
            // history.replaceState(null, document.title, expand); // 清除url订单号
            // this.doClone(orderId);
        },
        created() {
            this.$bus.$on("updatePayPanelStatus", (payload) => {
                for (let key in payload) {
                    this[key] = payload[key];
                }
            });
        },
        methods: {
            toVip() {
                let tType = this.work.member_free ? "cummunityVipTemplate" : "cummunityPayTemplates";
                this.$openBuyPage(tType);
                this.closeModal();
            },
            closeModal() {
                this.payway = "wxpay";
                this.showQrcode = false;

                this.cloneSucess = false;
                this.clonedObj = "";
                this.$refs.wxQrcode.innerHTML = "";

                this.wxPaySuccess = false;
                this.showPay = false;
            },
            close() {
                this.addTemplateRecent(this.workId);
                let winName = this.clonedObj,
                    href = window.location.origin + this.mapUrl + "?" + this.$zipFileName("obj=" + winName),
                    winref;
                if (this.openInTabs) {
                    location.href = href;
                } else {
                    winref = window.openPlus(href, winName);
                }
                if (winref.location.href === "about:blank") {
                    winref.location.href = href;
                }
                // add open record
                this.$store.commit("addWin", winref);
                let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                if (!openTabs.includes(winName)) {
                    openTabs.push(winName);
                }
                localStorage.setItem("openTabs", JSON.stringify(openTabs));

                this.showPay = false;
                let query = location.search && new URLSearchParams(location.search.slice(1));
                if (query && query.has("noClone")) return;

                this.$bus.$emit("closePreview");
            },
            //选择支付方式
            choosePayWay(way) {
                this.payway = way;
            },
            //开始支付
            submitOrder(e) {
                let callback = () => {
                    let id = this.params.id,
                        token = this.params.token,
                        work_id = this.preItem.id;
                    this.$edApi.submitOrder({ id, token, work_id }).then((res) => {
                        let code = res.code;
                        let refresh = res.refresh;
                        this.$refs.wxQrcode.src =
                            "data:image/svg+xml;utf8," +
                            this.create_qrcode(`${this.urls.accountUrl}/pay-max-store.html?pay_code=${code}&platform=pc`);
                        this.showQrcode = true;
                        this.$nextTick(() => {
                            this.$refs.dialog.resetPosition(); // 窗口居中
                        });
                        this.pollWxPay(code);
                        this.timer = setTimeout(() => {
                            callback();
                        }, refresh * 1000);
                    });
                };
                addJs(appConfig.sourcePath + "js/3rd/qrcode.min.js", callback);
            },

            create_qrcode(text) {
                qrcode.stringToBytes = qrcode.stringToBytesFuncs["UTF-8"];
                let qr = qrcode(0, "H");
                qr.addData(text, "Byte");
                qr.make();
                return qr.createSvgTag(2, 0);
            },
            // 轮询 支付宝 or 微信 是否支付成功
            pollWxPay(code) {
                var wxPayPoll = setInterval(() => {
                    this.doClone(code, "wx", wxPayPoll);
                }, 3000);
            },
            // 添加最近记录
            addTemplateRecent(id) {
                if (!this.$validateLogin()) return;
                this.$edApi
                    .addTemplateHistory({
                        user_id: this.userInfo.user_id,
                        token: this.userInfo.token,
                        data: {
                            template_id: id,
                            template_from: "COMMUNITY",
                        },
                    })
                    .then((e) => {
                        console.log("add subclass recent", e);
                        // this.initRecentData();
                    });
            },
            //根据订单，拷贝已买作品
            doClone(code, type, wxPayPoll) {
                let id = this.params.id,
                    token = this.params.token;
                if (!this.showPay) {
                    clearInterval(wxPayPoll);
                    return null;
                }
                this.$edApi.checkOrder({ id, token, code }).then((result) => {
                    if (result.status == "paid") {
                        if (type == "wx") {
                            if (this.wxPaySuccess) return; //微信支付成功之后，设置标志，阻止因为延迟导致的多次查询成功调用多次接口
                            this.showQrcode = false;
                            this.cloneSucess = true;
                            this.wxPaySuccess = true;
                            clearInterval(wxPayPoll);
                            clearTimeout(this.timer);
                        }
                        // if (this.isPC) {
                        // window.$qt.jsCallUploadData && window.$qt.jsCallUploadData(JSON.stringify({
                        //     type: "S006_Use_Template_8",
                        //     action: "SL042_Template_Pay_Success"
                        // }));
                        // }
                        let workId = result.work_id;
                        //如果是PC，克隆交给PC做，然后pc直接打开，不需要用户点击直接使用的按钮
                        this.$store.dispatch("getBoughtWorks").then(() => {
                            if (this.work.type == "edt") {
                                // 符号模板
                                this.$bus.$emit("paySymbolCallback", "success");
                                this.showPay = false;
                                return;
                            }
                            if (this.isPC) {
                                let { sign, exp, path } = result;
                                let callPcAction = (sign, exp, path, imgUrl) => {
                                    this.sensors.track("newFile", {
                                        Catalogues: "openFileProcess",
                                        new_file_type: "templates",
                                    });
                                    sign = encodeURIComponent(sign);
                                    let param = {
                                        id: workId,
                                        track: workId + "",
                                        fileName: this.work.title,
                                        sign,
                                        exp,
                                        obj: path,
                                        type: "clone",
                                        imgUrl,
                                        accessid: this.OSSAccessKeyId,
                                    };
                                    window.$qt.jsCallCloudFileOperate(JSON.stringify(param));
                                };
                                this.showPay = false;
                                let imgUrl = result.url ? `${window["GLOBAL"].PUBLIC_OSS_HOST + result.url}thumb.png` : "noImage";
                                callPcAction(sign, exp, path, imgUrl);
                            } else {
                                //把作品克隆到自己的云里
                                let limitCallback = (type = "") => {
                                    if (type == "showLimitCloudSpaceVIP") {
                                        if (this.fuser) {
                                            this.$bus.$emit("showCloudSpaceVipTips");
                                        } else {
                                            this.$checkAuth({
                                                type: "cloudSpaceVIP",
                                                buyTrigger: "cloudSpacePop",
                                                pcParams: { newUpgrade: 6, upgrade: 0 },
                                            });
                                        }
                                    } else if (type == "showLimitCloudSpace") {
                                        this.$checkAuth({
                                            type: "cloudSpace",
                                            buyTrigger: "cloudSpacePop",
                                            pcParams: { newUpgrade: 6, upgrade: 0 },
                                        });
                                    } else {
                                        this.$store.commit("toPublicStatus", {
                                            type: "showUpgrade",
                                            data: "fileNum",
                                        });
                                    }
                                    this.doingClone = false;
                                };
                                let enterCanvasTrack = `&file_source=templateFile&template_type=communityPaid&diagram_type=others`;
                                let trackSuffix = this.isAd ? `&from=ad` : "";
                                trackSuffix += enterCanvasTrack;
                                this.$openFile({
                                    params: {
                                        id,
                                        workId,
                                        token,
                                        platform: this.$store.state.publicStore.runPlatform,
                                    },
                                    fileType: "paidTemplate",
                                    suffix: trackSuffix,
                                    checkLimit: false,
                                    limitRange: this.$store.state.publicStore.runPlatform,
                                    limitCallback: limitCallback,
                                    vip: this.vip,
                                    isFullCouldSpace: this.isFullCouldSpace,
                                })
                                    .then((obj) => {
                                        this.workId = workId;
                                        this.showPay = true;
                                        this.cloneSucess = true;
                                        this.showQrcode = false;
                                        this.clonedObj = obj.obj;
                                        this.sensors.track("newFile", {
                                            Catalogues: "openFileProcess",
                                            new_file_type: "templates",
                                        });
                                    })
                                    .catch((err) => {
                                        if (err.msg == "noSpace") {
                                            this.$store.commit("toPublicShow", {
                                                type: "upgrade",
                                                data: "noSpace",
                                            });
                                            this.doingClone = false;
                                        }
                                    });
                            }
                        });
                    } else {
                        if (result.msg == "invalid code") {
                            clearInterval(wxPayPoll);
                        }
                    }
                });
            },
            toCredit() {
                this.showPay = false;
                this.closeModal();
                this.$store.commit("toTplCenter", {
                    name: "showCredit",
                    data: true,
                });
            },
        },
        beforeDestroy() {
            this.$bus.$off("updatePayPanelStatus");
        },
    };
</script>
<i18n>
{
  "zh": {
    "titlePay": "请扫描下方二维码支付",
    "titleUnit": "元",
    "titleClone": "克隆成功",
    "titleSelectPay": "请选择支付方式",
    "pay": "支付",
    "use": "立即使用",
		"limitTips": "你现在为非会员账号，购买模板后仍会受到会员功能限制。如您有使用上的疑问，请您关注公众号“亿图软件”或前往官网咨询客服。",
	"toVip": "开通VIP",
	"prize": "后不仅能<b>解锁限制</b>，还能享受此模板的<b>免单</b>福利！并且可获得最高价值<b>100元</b>的模板券！"
  },
  "en": {
    "titlePay": "Please scan the QR code below to pay",
    "titleUnit": "dollar",
    "titleClone": "cloned",
    "titleSelectPay": "Please select mode of payment",
    "pay": "Pay",
    "use": "Use immediately",
	"limitTips": "You are using the Free version. After purchasing the template, you will still only have access to Free features.",
	"toVip": "Upgrade to Premium",
	"prize": "to <b>unlock advanced features</b> and receive this template as a <b>free gift</b>! Plus a coupon for templates worth up to <b>100 RMB</b>!"
  },
  "de": {
    "titlePay": "Bitte scannen Sie den unten stehenden QR-Code, um zu bezahlen",
    "titleUnit": "元",
    "titleClone": "Erfolgreich geklont",
    "titleSelectPay": "Bitte wählen Sie die Zahlungsart",
    "pay": "Zahlen",
    "use": "sofort verwenden",
	"limitTips": "Sie verwenden die kostenlose Version. Nach dem Kauf dieser Vorlage sind Sie weiterhin auf die kostenlosen Funktionen beschränkt.",
	"toVip": "Führen Sie ein Upgrade auf Premium durch",
	"prize": " , um <b>erweiterte Funktionen freizuschalten</b>, und sichern Sie sich diese Vorlage als <b>kostenloses Geschenk</b>! Noch dazu einen Vorlagengutschein im Wert von bis zu <b>100 RMB</b>!"
  },
  "fr": {
    "titlePay": "Veuillez scanner le code QR ci-dessous pour payer",
    "titleUnit": "Euro",
    "titleClone": "Cloné avec succès",
    "titleSelectPay": "Veuillez sélectionner le mode de paiement",
    "pay": "Payer",
    "use": "Utiliser immédiatement",
	"limitTips": "Vous utilisez la version gratuite. Après avoir acheté le modèle, vous n'aurez toujours accès qu'aux fonctionnalités gratuites.",
	"toVip": "Passez à la version Premium",
	"prize": " pour <b>débloquer des fonctionnalités avancées</b> et recevoir ce modèle en <b>cadeau !</b> Plus un coupon pour des modèles d'une valeur maximale de <b>100 RMB</b> !"
  },
  "es": {
    "titlePay": "Escanee el código QR a continuación para pagar",
    "titleUnit": "元",
    "titleClone": "Clonado exitosamente",
    "titleSelectPay": "Seleccione el modo de pago",
    "pay": "Pagar",
    "use": "usar inmediatamente",
	"limitTips": "Está utilizando la versión Gratis. Después de adquirir la plantilla, seguirá teniendo acceso solo a las funciones gratuitas.",
	"toVip": "Actualice a Premium",
	"prize": " para <b>desbloquear funciones avanzadas</b> y recibir esta plantilla como un <b>regalo</b>. Además de un cupón para plantillas por valor de hasta <b>100 RMB</b>."
  },
  "jp": {
    "titlePay": "下記のQRコードをスキャンしてお支払いください",
    "titleUnit": "元",
    "titleClone": "正常に複製されました",
    "titleSelectPay": "お支払い方法を選択してください",
    "pay": "支払う",
    "use": "すぐに使う",
	"limitTips": "無料バージョンを使用しています。テンプレートの購入後も、無料の機能にのみアクセスできます。",
	"toVip": "高度な機能のロックを解除",
	"prize": "し、<b>無料のギフト</b>としてこのテンプレートを受け取るには、<a %1>プレミアムにアップグレード</a>してください。さらに、<b>100 RMB</b> 相当のテンプレートのクーポン。"
  },
  "pt": {
    "titlePay": "Leia o código QR abaixo para pagar",
    "titleUnit": "元",
    "titleClone": "Clonado com sucesso",
    "titleSelectPay": "Selecione a forma de pagamento",
    "pay": "Pagamento",
    "use": "usar imediatamente",
	"limitTips": "Você está usando a versão gratuita. Mesmo após a compra do modelo, você só terá acesso aos recursos gratuitos.",
	"toVip": "Atualize para a versão Premium",
	"prize": " para <b>desbloquear recursos avançados</b> e receber este modelo <b>gratuitamente</b>! Receba também um cupom para usar em modelos no valor de até <b>100 reais</b>!"
  },
  "it": {
    "titlePay": "Si prega di scansionare il codice QR qui sotto per pagare",
    "titleUnit": "元",
    "titleClone": "Clonato con successo",
    "titleSelectPay": "Seleziona la modalità di pagamento",
    "pay": "pagare",
    "use": "utilizzare immediatamente",
	"limitTips": "Stai utilizzando la versione gratuita. Dopo aver acquistato il modello, potrai accedere solo alle funzioni gratuite.",
	"toVip": "Passa alla versione Premium",
	"prize": " per <b>sbloccare funzioni avanzate</b> e ricevere questo modello come <b>regalo</b> gratuito! Nonché un buono per modelli del valore massimo di <b>100 RMB</b>!"
  },
  "tw": {
    "titlePay": "請掃描下方二維碼支付",
    "titleUnit": "元",
    "titleClone": "克隆成功",
    "titleSelectPay": "請選擇支付方式",
    "pay": "支付",
    "use": "立即使用",
	"limitTips": "您現在使用的是免費版本。購買範本後，您仍然只能存取免費功能。",
	"toVip": "升級至 Premiu",
	"prize": " 以<b>解鎖進階功能</b>，並獲得這個<b>免費的範本禮物</b>！加上價值最高 <b>100 元人民幣</b>的範本優惠券！"
  },
  "kr": {
    "titlePay": "아래 큐알 코드를 스캔하여 지불하세요~",
    "titleUnit": "원",
    "titleClone": "복제 성공",
    "titleSelectPay": "결제 방식 선택",
    "pay": "지불",
    "use": "바로 사용하기",
	"limitTips": "무료 버전을 사용하고 있습니다. 템플릿을 구입한 후에도 무료 기능만 사용할 수 있습니다.",
	"toVip": "프리미엄으로 업그레이드하면",
	"prize": " <b>고급 기능을 이용할 수</b> 있으며 이 템플릿을 <b>무료 선물로</b> 받을 수 있습니다. 최대 <b>100RMB</b> 상당의 템플릿 쿠폰이 추가로 제공됩니다!"
  },
  "id": {
    "titlePay": "Pindai kode QR di bawah ini untuk membayar",
    "titleUnit": "dolar",
    "titleClone": "dikloning",
    "titleSelectPay": "Pilih mode pembayaran",
    "pay": "Bayar",
    "use": "Gunakan segera",
	"limitTips": "Anda sedang menggunakan versi Gratis. Sekalipun telah membeli templat, Anda hanya akan memiliki akses ke fitur Gratis.",
	"toVip": "Tingkatkan ke Premium",
	"prize": " untuk <b>menikmati berbagai fitur tingkat lanjut</b> dan mendapatkan templat ini sebagai <b>hadiah gratis</b>! Plus kupon templat hingga <b>RMB100</b>!"
  }
}
</i18n>
